/**
 * Données de ComboBox
 */
export enum EnumComboBoxData {
    ConsumptionYears = 1,
    ConsumptionMonths = 2,
    Goal = 3,
    HeatingSeason = 4,
    Factor = 5
}